<script setup>
const props = defineProps({
  company: {
    type: Object,
    required: true,
  },
})

const user = useStrapiUser()
const { upload } = useUploadUtils()

const isProfessional = computed(() => user.value?.type === 'professional')
const score = computed(
  () =>
    props.company?.matchings?.find((match) => match.type === 'total')?.score,
)
</script>

<template>
  <div class="pt-8 lg:pt-0">
    <h3
      v-if="score"
      class="text-md mb-6 mt-0 text-center font-sans font-semibold text-secondary lg:mt-12 lg:text-left"
    >
      Match met bedrijf
    </h3>
    <div>
      <div class="relative flex shrink-0">
        <NuxtLink v-if="company.logo?.url" :to="`/companies/${company?.slug}`">
          <div
            class="absolute bottom-[24px] left-[24px] z-20 h-[80px] w-[80px] overflow-hidden rounded-md bg-white"
          >
            <img
              :src="upload(company.logo, 'thumbail')"
              class="h-full w-full object-contain"
            />
          </div>
        </NuxtLink>
        <figure
          v-if="company?.media?.[0]"
          class="relative flex h-[208px] w-full max-w-full overflow-hidden"
          :class="{ 'mask-card': score }"
        >
          <BaseVisual
            :file="company?.media?.[0]"
            class="w-full bg-white"
            size="small"
            cover
            width="164px"
            height="194px"
            type="image"
          />
        </figure>
        <div
          v-else
          class="mask-card relative flex h-[208px] w-full bg-primary"
        ></div>
        <div
          v-if="score"
          class="absolute right-[17px] top-[17px] h-[75px] w-[75px] rounded-[50%] bg-secondary"
        ></div>
        <ClientOnly>
          <component
            :is="resolveComponent('VeProgress')"
            v-if="score"
            class="absolute right-[15px] top-[7px] mt-2 h-[80px] w-[80px]"
            :progress="Number(score.toFixed())"
            :legend-formatter="({ currentValue }) => `${currentValue || '-'}%`"
            color="#9EFF28"
            empty-color="#E7EDF3"
            :size="80"
            :thickness="4"
            :empty-thickness="2"
            animation="bounce 1500 500"
            font-size="0.9rem"
            font-color="#FFFFFF"
            dot="0"
          />
        </ClientOnly>
      </div>
    </div>
    <div
      class="rounded-md rounded-t-none border border-t-0 border-solid border-gray-400 bg-white p-6"
    >
      <h3 class="text-md mb-4 font-sans font-semibold text-secondary">
        {{ company.name }}
      </h3>

      <p class="mb-8">
        {{ company.address?.address }}, {{ company.address?.city }}
      </p>

      <ButtonInterest
        v-if="isProfessional && company?.id"
        target-type="company"
        :target-id="company?.id"
        class="mb-2 w-full"
      />

      <Button
        :path="`/companies/${company?.slug}`"
        theme="primary"
        text="Bekijk bedrijf"
        size="md"
        class="w-full"
      />
    </div>
  </div>
</template>
